import { render, staticRenderFns } from "./DeleteDomainPopup.vue?vue&type=template&id=8d372c86&scoped=true"
import script from "./DeleteDomainPopup.vue?vue&type=script&lang=js"
export * from "./DeleteDomainPopup.vue?vue&type=script&lang=js"
import style0 from "./DeleteDomainPopup.vue?vue&type=style&index=0&id=8d372c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d372c86",
  null
  
)

export default component.exports